var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6872 11.8266L13.1638 14.3501V4H11.8356V14.3501L9.31217 11.8266L8.37305 12.7657L12.4997 16.8924L16.6264 12.7657L15.6872 11.8266Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.672 16.8926V21.5079C19.672 21.874 19.3741 22.1719 19.008 22.1719H5.99221C5.62604 22.1719 5.32814 21.874 5.32814 21.5079V16.8926H4V21.5079C4 22.6064 4.8937 23.5001 5.99221 23.5001H19.008C20.1065 23.5001 21.0002 22.6064 21.0002 21.5079V16.8926H19.672Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.ccbc3f26054f3ef94cd4974c173a6416.svg";
export { ForwardRef as ReactComponent };